import React from 'react';
import { TreatEveryoneIcon, MindIcon, TakeCareIcon, AcknowledgeIcon, EmergencyIcon, EmergencyHomeIcon, RemoteControllerIcon, WheelControllerIcon, KeyboardControllerIcon } from './svgicon';
import GamepassBottomImage from '@images/gamepassBottomImage.png';
import GamePassImg from '@images/gamepass.png';
import LifePointFive from '@images/game-pass/LifePointFive.png';
import LifePointTen from '@images/game-pass/LifePointTen.png';
import FireIcon from '@images/game-pass/fire_icon.svg';
import diversityIcon from '@images/testdrive/diversity_2.svg';
import flagsIcon from '@images/testdrive/emoji_flags.svg';
import eventsIcon from '@images/testdrive/emoji_events.svg';
const isBrowser = typeof window !== 'undefined';

const getParameterByName = (name) => {
  const url = isBrowser ? window.location.href : '';
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const getModeByUrl = () => {
  const pathname = isBrowser ? window.location.pathname.replace(/\//g, "") : '';
  return pathname;
}

const isLatLogValid = (lat, long) => {
  return isFinite(long) && Math.abs(long) <= 180 && isFinite(lat) && Math.abs(lat) <= 90;
}

const GetSortOrder = (prop) => {
  return function (a, b) {
    if (a[prop] > b[prop]) {
      return 1;
    } else if (a[prop] < b[prop]) {
      return -1;
    }
    return 0;
  }
}

const getDistanceFromLatLonInKm = (botDetail, mission) => {
  const lat1 = botDetail?.latitude;
  const lon1 = botDetail?.longitude;
  const lat2 = mission?.latitude;
  const lon2 = mission?.longitude;
  var R = 6371000; // Radius of the earth in m
  var dLat = deg2rad(lat2 - lat1);  // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in m
  return d;
}

const deg2rad = (deg) => {
  return deg * (Math.PI / 180)
}

const batterystyle = {
  batteryBody: {
    strokeWidth: 6,
    cornerRadius: 10,
    fill: 'none',
    strokeColor: '#FFFFFF'
  },
  batteryCap: {
    fill: 'none',
    strokeWidth: 6,
    strokeColor: '#FFFFFF',
    cornerRadius: 2,
    capToBodyRatio: 0.4
  },
  batteryMeter: {
    fill: '#FFFFFF',
    lowBatteryValue: 15,
    lowBatteryFill: '#FF0000',
    outerGap: 5,
    noOfCells: 1,
    interCellsGap: 0,
  },
  chargingFlash: {
    scale: undefined,
    fill: 'red',
    animated: true,
    animationDuration: 100
  },
}

const calculateBearing = (lat1, lon1, lat2, lon2) => {
  const φ1 = lat1 * Math.PI / 180;
  const φ2 = lat2 * Math.PI / 180;
  const Δλ = (lon2 - lon1) * Math.PI / 180;

  const y = Math.sin(Δλ) * Math.cos(φ2);
  const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
  let brng = Math.atan2(y, x) * 180 / Math.PI;

  // convert bearing to range 0° to 360°
  brng = (brng + 360) % 360;

  return brng;
}

const WALLET_ADAPTERS = {
  AUTH: 'auth'
}

const CHAIN_NAMESPACES = {
  SOLANA: "solana"
}

const OpenWorldLoadingScreenData = [
  {
    title: 'Treat everyone with respect',
    description: 'Operate the robot responsibly, respecting others with your actions and words. Avoid causing harm or disturbance during your journey.',
    icon: <TreatEveryoneIcon />
  },
  {
    title: 'Mind your surroundings ',
    description: 'Avoid destructive behaviour, including damaging property or crashing intentionally. Remember, your actions have a real-world impact.',
    icon: <MindIcon />
  },
  {
    title: 'Take care of your FrodoBot',
    description: (
      <>
        Watch for obstacles and roads. If you abandon your FrodoBot{' '}
        <span style={{ color: '#FF1053' }}>without completing the drive, you will lose LP and be kicked out.</span>
      </>
    ),
    icon: <TakeCareIcon />
  },
  {
    title: 'You acknowledge you are responsible',
    description: (
      <>
        Be aware that violating these rules may result in loss of LP or,{' '}
        <span style={{ color: '#FF1053' }}>in severe cases, removal from the entire FrodoBots service.</span>
      </>
    ),
    icon: <AcknowledgeIcon />
  }
]

const TestDriveLoadingScreenData = [
  {
    title: 'Don’t bump into others',
    description: (
      <>
        Operate the robot responsibly, as there are others in the area with you.{' '}
        <span style={{ color: '#FF1053' }}>Do not bump into other FrodoBots intentionally.</span>
      </>
    ),
    icon: <TreatEveryoneIcon />
  },
  {
    title: 'Don’t damage surroundings',
    description: (
      <>
        Avoid destructive behaviour, including damaging property{' '}
        <span style={{ color: '#FF1053' }}>or crashing intentionally. Remember, your actions have a real-world impact.</span>
      </>
    ),
    icon: <MindIcon />
  },
  {
    title: 'Don’t abandon the FrodoBot',
    description: (
      <>
        If you abandon your FrodoBot{' '}
        <span style={{ color: '#FF1053' }}>without completing the drive, you will be kicked out.</span>
      </>
    ),
    icon: <TakeCareIcon />
  },
  {
    title: 'You acknowledge you are responsible',
    description: (
      <>
        Be aware that violating these rules may result in being kicked or,{' '}
        <span style={{ color: '#FF1053' }}>in severe cases, removal from the entire FrodoBots service.</span>
      </>
    ),
    icon: <AcknowledgeIcon />
  }
]

const PermanentBenRules = [
  {
    icon: <EmergencyIcon />,
    title: 'Direct impact causing harm on to civilians',
    description: 'If the FrodoBot is being used to intentionally harm life and disrupt civilians, the user will immediately paused and removed from the service.'
  },
  {
    icon: <EmergencyIcon />,
    title: 'Driving off stairs/curbs on purpose',
    description: 'Users must avoid maneuvering FrodoBots off stairs or curbs intentionally. Such actions can lead to damage to the robot and pose a risk to public safety. FrodoBots are designed for sidewalk use, and deviation from this can result in immediate suspension from the service.'
  },
  {
    icon: <EmergencyIcon />,
    title: 'Attempting to cause accidents',
    description: 'Deliberately driving FrodoBots onto highways or roads is strictly prohibited. This behavior not only endangers the robot but also poses significant risks to motorists and can cause traffic disturbances. Violation of this rule will lead to an immediate ban.'
  },
  {
    icon: <EmergencyIcon />,
    title: 'Driving and crashing into cars on purpose',
    description: 'Users are prohibited from intentionally crashing FrodoBots into vehicles. This action is deemed as vandalism and poses a safety risk, and it will result in immediate removal from the service.'
  },
  {
    icon: <EmergencyIcon />,
    title: 'Disturbing local civilians in their daily life ',
    description: 'FrodoBots should not be used to intentionally disrupt or disturb civilians. Respect for the general public is paramount, and users found harassing or causing discomfort to others will be promptly removed from the service.'
  },
  {
    icon: <EmergencyIcon />,
    title: 'Crashing into obstacles/structures',
    description: 'Intentional crashing of FrodoBots into any obstacles or structures is not allowed. This can lead to damage to both the robot and property, and such reckless behaviour will result in immediate suspension from the service.'
  },
  {
    icon: <EmergencyIcon />,
    title: 'Crashing bots into public items on purpose',
    description: 'Users must not deliberately crash FrodoBots into public items like bikes, chairs, or tables. This is considered vandalism and a disturbance to public order, leading to immediate removal from the service.'
  }
]

const ResultRules = [
  {
    icon: <EmergencyHomeIcon />,
    title: 'Chasing after pets',
    description: 'Users should avoid using FrodoBots to chase or harass pets. While this may not cause immediate harm, it can distress animals and their owners, leading to a warning.'
  },
  {
    icon: <EmergencyHomeIcon />,
    title: 'Intentionally going into bodies of water',
    description: 'Deliberately driving FrodoBots into bodies of water is prohibited. This not only damages the robot but also poses environmental concerns. Users will receive a warning for such actions.'
  },
  {
    icon: <EmergencyHomeIcon />,
    title: 'Follow/stalking civilians for a long time',
    description: `It's essential to respect individual privacy. Using FrodoBots to follow or stalk people for extended periods is inappropriate and will result in a warning.`
  },
  {
    icon: <EmergencyHomeIcon />,
    title: 'Crashing into piles of sticks or plants',
    description: 'While less severe, crashing into natural elements like sticks or plants without necessity is discouraged. Users will be warned to prevent potential environmental disturbances.'
  },
  {
    icon: <EmergencyHomeIcon />,
    title: 'Going off route/mission points',
    description: 'Users are expected to stick to designated routes or mission points. Deviating from these paths without a valid reason will lead to a warning, as it can disrupt the intended gameplay experience.'
  },
]

const calculateBotDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6378137.0; // Earth's radius in meters
  const latRad1 = toRadians(lat1);
  const lonRad1 = toRadians(lon1);
  const latRad2 = toRadians(lat2);
  const lonRad2 = toRadians(lon2);

  const dLat = latRad2 - latRad1;
  const dLon = lonRad2 - lonRad1;

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(latRad1) * Math.cos(latRad2) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c;
  return distance;
}

const toRadians = (degrees) => {
  return degrees * (Math.PI / 180);
}

const updateCoordinates = (data) => {
  const DISTANCE_THRESHOLD = 50;
  const newData = [];

  for (let i = 0; i < data.length; i++) {
    for (let j = i + 1; j < data.length; j++) {
      if (data[i].id !== data[j].id && data[i].status !== 'test_ready') {
        const distance = calculateBotDistance(data[i].latitude, data[i].longitude, data[j].latitude, data[j].longitude);
        if (distance <= DISTANCE_THRESHOLD || distance === 0) {
          // Example usage
          const initialLat = data[i].latitude;
          const initialLon = data[i].longitude;
          const bearing = 90; // East direction
          const distance = 110; // 100 meters

          const newCoordinates = moveCoordinates(initialLat, initialLon, distance, bearing);
          data[i].latitude = newCoordinates.lat
          data[i].longitude = newCoordinates.lon
        }
      }
    }
    newData.push(data[i]);
  }

  return newData;
}

const moveCoordinates = (lat, lon, distance, bearing) => {
  // Earth's radius in meters
  const R = 6371000;

  // Convert distance to radians
  const distRadians = distance / R;

  // Convert bearing to radians
  const bearingRadians = (bearing * Math.PI) / 180;

  // Convert latitude and longitude to radians
  const lat1 = (lat * Math.PI) / 180;
  const lon1 = (lon * Math.PI) / 180;

  // Calculate new latitude
  const lat2 = Math.asin(
    Math.sin(lat1) * Math.cos(distRadians) +
    Math.cos(lat1) * Math.sin(distRadians) * Math.cos(bearingRadians)
  );

  // Calculate new longitude
  const lon2 =
    lon1 +
    Math.atan2(
      Math.sin(bearingRadians) * Math.sin(distRadians) * Math.cos(lat1),
      Math.cos(distRadians) - Math.sin(lat1) * Math.sin(lat2)
    );

  // Convert latitude and longitude back to degrees
  const newLat = (lat2 * 180) / Math.PI;
  const newLon = (lon2 * 180) / Math.PI;

  return { lat: newLat, lon: newLon };
}

const mapValue = (value, fromMin, fromMax, toMin, toMax) => {
  // Calculate the percentage of completion within the input range
  const percentage = (value - fromMin) / (fromMax - fromMin);

  // Map the percentage to the output range
  const mappedValue = toMin + percentage * (toMax - toMin);

  return mappedValue;
}

const BuyLifePointDataItem = [
  // {
  //   lifeimg: LifePointOne,
  //   timecrid: '+ 5 Time Credits!',
  //   timecradit: '1 Life Point Pass',
  //   usd: '9.99 USD',
  //   amount: '9.99',
  //   pragraph: 'Just want to dip your toes into the pool without too much investment? This is a great trial starter.',
  //   tcstyle: '-mt-[44px]',
  // },
  {
    lifeimg: LifePointFive,
    timecrid: '+ 20 Time Credits!',
    timecradit: '5 Life Point Pass',
    usd: '39.99 USD',
    amount: '39.99',
    lp: '$8 / LP!',
    pragraph: "A great start for anyone's adventure around the world. Enjoy the rides and have some assurance with extra Life Points.",
    tcstyle: '-mt-[63px]',
    // text: 'Most popular!',
    icon: FireIcon
  },
  {
    lifeimg: LifePointTen,
    timecrid: '+ 30 Time Credits!',
    timecradit: '10 Life Point Pass',
    lp: '$5 / LP!',
    usd: '49.99 USD',
    amount: '49.99',
    pragraph: "Ideal for gamers who don't mind paying a bit more for a cheaper price per LP.",
    tcstyle: '-mt-[63px]'
  },
]

const LifePointPassUseDetails = [
  {
    title: "Buy a Life Points Pass",
    pragraph: 'This serves as your game pass to the open-world mode. Each account begins with 0 XP (Experience Points).',
    detalis: "Each pass provides you a certain number of life points. Life Points (LP) are deducted for not completing a mission, reckless driving, and more.",
  },
  {
    title: "Activate your account",
    pragraph: 'A quick 1 minute verification (with a government-issued ID) is required to confirm you are above 16 years old.',
    detalis: "If you've already done this, then you can skip this step and get right to driving!",
  },
  {
    title: "Start driving!",
    pragraph: 'Welcome aboard! Get a game controller or steering wheel ready in order to explore.',
    detalis: " Drive responsibly and complete missions to keep enjoying your journey. Remember, missions become more challenging! Life points are only consumed when you fail a mission or when a disruption is detected.",
  }
]

const bottomcontainerGamepassStyle = {
  backgroundImage: `url(${GamepassBottomImage})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  width: '100%',
  marginTop: '-84px',
  height: '500px',
};

const topContainerGamepassStyle = {
  backgroundImage: `url(${GamePassImg})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
};

const timeZoneAbbreviated = () => {
  const { 1: tz } = new Date().toString().match(/\((.+)\)/);

  if (tz.includes(" ")) {
    return tz
      .split(" ")
      .map(([first]) => first)
      .join("");
  } else {
    return tz;
  }
};

const getDaySuffix = (day) => {
  if (day > 3 && day < 21) return 'th'; // For 4th to 20th
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

const playData = [
  {
    label: "Prepare your Game Controller",
    details: "You can also play with your keyboard or steering wheel controller!",
    icons: diversityIcon,
  },
  {
    label: "Find 7 checkpoints",
    details: "You have 15 mins to find at least 7 checkpoints!",
    icons: flagsIcon,
  },
  {
    label: "Unlock Open-World Game!",
    details: "Get ready for some real world driving!",
    icons: eventsIcon,
  },
];

const controllerData = [
  {
    label: "Start with controller",
    connect: 'Connected!',
    disconnect: 'Not connected',
    control: 'Remote',
    wait: 'Waiting for controller input...',
    icons: <RemoteControllerIcon />,
  },
  {
    label: "Start with driving wheel",
    connect: 'Connected!',
    disconnect: 'Not connected',
    control: 'Wheel',
    wait: 'Waiting for controller input...',
    icons: <WheelControllerIcon />,
  },
  {
    label: "Start with keyboard",
    connect: 'Good to go!',
    control: 'KeyBoard',
    icons: <KeyboardControllerIcon />,
  },
];

const removeKey = [
  "Spacebar",
  "Alt",
  "CapsLock",
  "Shift",
  "Control",
  "Meta",
  "Backspace",
  "Delete",
  "Tab",
  "Escape",
  "`",
  " "
]

export {
  playData,
  LifePointPassUseDetails,
  getDaySuffix,
  timeZoneAbbreviated,
  BuyLifePointDataItem,
  bottomcontainerGamepassStyle,
  topContainerGamepassStyle,
  mapValue,
  updateCoordinates,
  ResultRules,
  PermanentBenRules,
  OpenWorldLoadingScreenData,
  TestDriveLoadingScreenData,
  CHAIN_NAMESPACES,
  WALLET_ADAPTERS,
  calculateBearing,
  batterystyle,
  getParameterByName,
  isLatLogValid,
  GetSortOrder,
  getDistanceFromLatLonInKm,
  getModeByUrl,
  controllerData,
  removeKey
}